import { GetterTree } from 'vuex';
import { IAgendaState } from './agenda-state.store';
import { IRootState } from '../root-state.store';
//@ts-ignore
import { IAppointment } from '@/models/appointment';
//@ts-ignore
import { ActivityStatus } from '@/common/enums';
import { IAppointmentListing } from '../../models/appointment';
import { DateTimeHelper } from '../../utils/DateTimeHelper.util';

export const getters: GetterTree<IAgendaState, IRootState> = {
  service: (state: IRootState) => state.service
  , activityStatus: (state: IRootState): ActivityStatus => {
    return state.activityStatus;
  }
  , appointments: (state: IAgendaState): IAppointment[] => {
    return state.appointments;
  }
  , eventDotsForDatepicker: (state: IAgendaState): string[] => {
    const dates = state.appointments.map((appointment) => {
      return DateTimeHelper.parseISODate(appointment.start_date) || '';
    });
    return new Array(...new Set(dates));
  }
  , appointment: (state: IAgendaState): IAppointment => {
    return state.appointment;
  }
  , originAppointment: (state: IAgendaState): IAppointment => {
    return state.originAppointment;
  }
  , originUpdatingAppointment: (state: IAgendaState): IAppointment => {
    return state.originUpdatingAppointment;
  }
  , appointmentParameter: (state: IAgendaState) => state.appointmentParameter
  , loaders: (state: IAgendaState): Map<string,boolean> => state.loaders
}


// WEBPACK FOOTER //
// ./src/store/agenda/agenda-getters.store.ts